import { action, observable } from 'mobx';
import { toast } from '../components/notice';
import { baseRequest, register } from '../operates';
import store from '../store'
import { push } from '../utils';

class RegisterVip {

    @observable public code: string = ''; // 验证码
    @observable public phone: string = ''; // 手机号
    @observable public codeTime: number = 0; // 倒计时
    @observable public isAgain: boolean = false; // 是否是重新获取
    @observable public timer: any; // 是否是重新获取
    private isGetCode: boolean = true; // 阻止多次点击获取验证码

    constructor() {

    }

    @action('获取验证码')
    obtainCode() {
        if (this.codeTime > 0) return false;
        if (!this.isGetCode) return false;
        this.isGetCode = false;
        if (this.phone.length === 0) {
            toast('请输入手机号');
            this.isGetCode = true;
            return false;
        }
        if (this.phone.length < 11) {
            toast('请填写正确手机号格式');
            this.isGetCode = true;
            return false;
        }
        baseRequest('user/common/v1/8/send/message', {
            mobile: this.phone
        }, (data, errCode, errDesc) => {
            this.isGetCode = true;
            if (errCode === 200) {
                toast('验证码已发送');
                sessionStorage.setItem('code_time_vip', '60');
                this._countDown(60);
                return false;
            } else {
                toast(errDesc);
            }
        });
    }

    @action('倒计时')
    _countDown(time: number): void {
        this.timer = setInterval(() => {
            --time;
            this.codeTime = time;
            this.isAgain = true;
            sessionStorage.setItem('code_time_vip', String(time));
            if (time <= 0) {
                clearInterval(this.timer);
                sessionStorage.removeItem('code_time_vip');
            }
        }, 1000);
    }

    @action('注册')
    onRegister(_this: any) {
        if (this.phone.length === 0) {
            toast('请输入手机号');
            return false;
        }
        if (this.phone.length < 11) {
            toast('请填写正确手机号格式');
            return false;
        }
        if (this.code.length === 0) {
            toast('请输入验证码');
            return false;
        }
        register('user/v1/vip/register', {
            agentId: store.user.partnerId,
            mobile: this.phone,
            vcode: this.code
        }, (data) => {
            if (data.errCode == 200) {
                push(`/registerVipStatusPage/1`, _this)
            } else {
                toast(data.errDesc);
            }
        });
    }
}

export default RegisterVip;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/RegisterVip.ts